import config from '~/src/App/config'
import safeStorage from '~/src/Lib/safeStorage'

const TEST_SOLUS_ONLY_KEY = 'testSolusOnly'
const SOLUS_EMULATE_SENSOR_TYPE_KEY = 'solusEmulateSensorType'

export type SolusEmulateSensorType = 'ter12' | 'ter15'

export const isSolusOnlyDevOverride = (): boolean => {
  try {
    return config.ENVIRONMENT !== 'production' && safeStorage().getItem(TEST_SOLUS_ONLY_KEY) === 'true'
  } catch {
    console.warn(`Failed to read ${TEST_SOLUS_ONLY_KEY} from storage.`)
    return false
  }
}

export const getSolusEmulateSensorType = (): SolusEmulateSensorType | null => {
  if (config.ENVIRONMENT === 'production') return null

  try {
    const value = safeStorage().getItem(SOLUS_EMULATE_SENSOR_TYPE_KEY)
    return value === 'ter12' || value === 'ter15' ? value : null
  } catch (caught) {
    console.warn(`Failed to read ${SOLUS_EMULATE_SENSOR_TYPE_KEY} from storage.`, caught)
    return null
  }
}
